import React, { Component } from 'react'
import Background from '../Background/Background.jsx'

class Registration extends Component {
  render() {
    return (
      <Background />
    )
  }
}

export default Registration;
